import { FormGroup } from '@ksyos/design-system';
import type { IKisSettingAddEditValidated } from '@common/validation/kisSetting';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils';
import type { IGroup } from './GroupsAddEdit';
import { InputCheckbox } from '../../../elements/common';
import { KisSettingAddEdit } from './KisSettingAddEdit';

interface ExtraGroupSettingsEditProps {
    errors: ValidationErrors;
    group: IGroup;
    handleChange: <K extends keyof IGroup>(name: K, value: IGroup[K]) => Promise<void>;
    handleKisSettingChange: <K extends keyof IKisSettingAddEditValidated>(
        name: K,
        value: IKisSettingAddEditValidated[K]
    ) => Promise<void>;
    validateOne: (name: string) => Promise<void>;
}

export function ExtraGroupSettingsEdit(props: Readonly<ExtraGroupSettingsEditProps>) {
    const translate = getSelectedLanguage();

    return (
        <>
            <FormGroup
                hasErrors={props.errors.has('isActive')}
                label={translate.groups.isActive}
            >
                <InputCheckbox
                    checked={props.group.isActive}
                    error={getValidationErrorTranslation(props.errors.get('isActive'))}
                    onChange={async (value) => await props.handleChange('isActive', value)}
                />
            </FormGroup>
            <KisSettingAddEdit
                {...props}
                kisSetting={props.group.kisSetting}
            />
        </>
    );
}
